@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-line-chart {
    padding: 0;

    // ==== Chart Background

    &.has-background {
      background-color: var(--background-color);
      box-shadow: var(--drop-shadow);
      border-radius: var(--G-border-radius);
    }

    // ==== Title

    .title-container {
      text-align: center;
      margin-block-start: 1em;
      margin-block-end: 1em;

      &:has(~ .subtitle-container) {
        margin-block-end: 0;
      }
    }

    // ==== Subtitle

    .subtitle-container {
      text-align: center;
      margin-block-end: 1em;
    }

    // ==== Chart Container

    .chart-container {
      position: relative;
      display: flex;
      align-items: center;
    }

    // ==== Canvas

    canvas {
      display: block;
    }
  }
}
